import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer className="py-2 px-2 shadow">
        <p className="mb-0 text-white">
          © {new Date().getFullYear()} Version 1.61
          <br /> Orange Enterprises, Inc.
        </p>
      </footer>
    );
  }
}

export default Footer;
